import { fetchWithCache, getCachedData } from "../services/apiService";

export const allUsers = async (setAll) => {
  // Show cached data immediately if available
  const cached = getCachedData("/api/user/allUsers", {});
  if (cached && Array.isArray(cached) && cached.length > 0) {
    setAll(cached);
  }

  try {
    // Fetch fresh data; falls back to cache if API is sleeping
    const data = await fetchWithCache(
      "/api/user/allUsers",
      {
        method: "GET",
        retries: 2,
        timeout: 10000,
      },
      true,
    );

    if (Array.isArray(data) && data.length > 0) {
      setAll(data);
    } else if (!cached || !cached.length) {
      setAll(data || []);
    }
    return data;
  } catch (error) {
    if (!cached || !cached.length) {
      setAll([]);
    }
    return cached || [];
  }
};
